"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SingleStyleInjector = /** @class */ (function () {
    function SingleStyleInjector(document) {
        this.document = document;
    }
    SingleStyleInjector.prototype.inject = function (styles) {
        var css = this.document.createElement('link');
        css.rel = 'stylesheet';
        css.href = styles;
        this.document.head.appendChild(css);
    };
    return SingleStyleInjector;
}());
exports.SingleStyleInjector = SingleStyleInjector;
//# sourceMappingURL=SingleStyleInjector.js.map